import React from 'react';
import { motion, AnimatePresence  } from "framer-motion";
import {Notification, NotificationStatus } from '../../../interfaces/unsplash';

const NotificationBar = ({ show, notificationStatus }: Notification) => {

    const notificationMsg = () => {  
        if (notificationStatus === NotificationStatus.success){
            return "Your Unsplash image has been added to your images in the Media Library";
        }

        if (notificationStatus === NotificationStatus.error){
            return "Something went wrong, please try to Add to Library again";
        }
    } 

    return (
        <AnimatePresence>
            {show && (
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    id="notificationHub-react">
                        <div className={notificationStatus}>{notificationMsg()}</div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default NotificationBar;